import { type ComputedRef, computed } from 'vue';
import { type IdentityApplicationFeaturesUsersGetUserProfileUserProfileDto } from '@services/identity-api/orval-api/model/identityApplicationFeaturesUsersGetUserProfileUserProfileDto';
import { useGetApiV1UserProfile } from '@services/identity-api/orval-api/user-api/user-api';

export function useProfile(): ComputedRef<
  IdentityApplicationFeaturesUsersGetUserProfileUserProfileDto | undefined
> {
  const { data } = useGetApiV1UserProfile({ query: { staleTime: 60 * 1000, retry: 10 } });
  return computed(() => data.value);
}
